import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { FaFilter } from "react-icons/fa";
import Table from "react-bootstrap/Table";
import { CSVLink } from "react-csv";

import ApiUiController from "../../controller/ApiUiController";
import ReportAPI from "../../api/ReportAPI";
import FilterDate from "../filter/FilterDate";
import Const from "../../util/Constants";
import FilterPannel from "../filter/FilterPannel";
import withRouter from "../../util/WithRouter";
import Util from "../../util/Util";
import ReportController from "../../controller/ReportController";
import Button from "react-bootstrap/Button";

class ReportTime3D extends React.Component {
  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);

    this.export = [];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.children = [user.user_id, ...user.child];

    this.report = props.report;
    this.rows = null;
    this.state = { isFilterOpen: true, inApiCall: true };
    this.model = {};
    this.Restrict = true;

    const model = this.models[this.report.model];
    this.model = model;
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);

    const filters = [];
    if (this.report.filter) {
      const filter = JSON.parse(this.report.filter);
      for (let i = 0; i < filter.length; i++) {
        filters.push({ ...filter[i] });
        filters[i].value = FilterDate.getValue(filters[i].value);
      }
    }
    this.filters = filters;
  }

  componentDidMount() {
    this.loadReports();
  }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onData = res => {
    this.res = res;
    new Promise((resolve) =>
      resolve(this.calculte(res))).then(data => this.setState({ ...this.state, inApiCall: false }));
  };

  onFilterChange = (filters) => {
    this.setState({ ...this.state, inApiCall: true });
    this.filters = filters;
    this.loadReports();
  };

  loadReports = () => {
    const restrict = this.filters.find(
      (filter) => filter.field === "responsible_person"
    );
    if (this.Restrict && !restrict) {
      this.filters.push({
        field: "responsible_person",
        type: "multiselect~user",
        condition: "in",
        value: `${Const.Opt}${this.children.join(Const.Opt)}${Const.Opt}`,
      });
    }
    ReportAPI.data(this.report.id, this.filters, this.onData, this.onFail);
  };

  calculte = data => {
    const model = this.models[this.report.model];
    if (!model) return { headers: [], body: [] };

    const x = this.report.x;
    const y = this.report.y;
    const z = this.report.z;

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [user.user_id, ...user.child];
    let xOptions = ReportController.getOptions(model.fields[x], true);
    if (this.restrict && model.fields[x].field_type.includes("~user")) {
      xOptions = xOptions.filter(
        (opt) =>
          children.find((child) => parseInt(child) === parseInt(opt.value)) !==
          undefined
      );
    }
    let filter = this.filters.find(filter => filter.field === model.fields[x].field_key);
    if (filter) {
      xOptions = xOptions.filter(opt => filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));
    }
    this.xOptions = xOptions;

    //Preparing axis
    this.xOpts = this.xOptions.map(opt => { return { label: opt.label, value: opt.value }; });
    this.xOpts = [...this.xOpts, { label: 'Unassign', value: -1 }];
    this.yOpts = ReportController.getHeaderDate(this.filters, model.fields[y]);
    this.zOpts = ReportController.getOptions(model.fields[z], true);
    this.zOpts = [...this.zOpts, { label: 'Unassign', value: -1 }];

    //preparing counts
    const rows = this.yOpts.map(opt => {
      return {
        label: opt.label,
        value: opt.value,
        subRows: this.zOpts.map(opt => {
          return {
            label: opt.label,
            value: opt.value,
            cols: this.xOpts.map(opt => {
              return {
                label: opt.label,
                value: opt.value,
                count: 0
              };
            })
          };
        }),
        rowTotal: this.zOpts.map(opt => 0),
        colTotal: this.xOpts.map(opt => 0),
        total: 0
      };
    });
    const total = {
      counts: this.zOpts.map(opt => this.xOpts.map(opt => 0)),
      rowTotal: this.zOpts.map(opt => 0),
      colTotal: this.xOpts.map(opt => 0),
      total: 0
    };

    const xType = model.fields[x].field_type.split(Const.Opt)[0];
    const yType = model.fields[y].field_type.split(Const.Opt)[0];
    const zType = model.fields[z].field_type.split(Const.Opt)[0];

    //counting data
    for (let i = 0; i < data.length; i++) {
      const iX = ReportController.getIndexValue(xType, x, this.xOpts, data[i][x]);
      const iY = ReportController.getIndexValue(yType, y, this.yOpts, data[i][y]);
      const iZ = ReportController.getIndexValue(zType, z, this.zOpts, data[i][z]);

      //add count
      if (iX !== null && iX !== undefined && iY !== null && iY !== undefined && iZ !== null && iZ !== undefined) {
        //individual row
        rows[iY].subRows[iZ].cols[iX].count++;
        rows[iY].rowTotal[iZ]++;
        rows[iY].colTotal[iX]++;
        rows[iY].total++;

        //grand total
        total.counts[iZ][iX]++;
        total.rowTotal[iZ]++;
        total.colTotal[iX]++;
        total.total++;
      }
    }
    this.rows = rows;
    this.total = total;
    return rows;
  };

  loadView = (row, col) => {
    const iCol = col - 2;
    if (iCol < 0) {
      return;
    }

    const subRows = this.zOpts.length + 1;
    const iRow = (row - (row % subRows)) / subRows;
    const iSubRow = row - (iRow * subRows);

    let filters = [...this.filters];
    /*
    if (j === 0) return;
    let filters = [...this.filters];
    let yValue;
    if (i < this.yOptions.length) {
      yValue = this.yOptions[i].value;
    } else {
      yValue =
        `${this.yOptions[0].value.split(Const.Opt)[0]}${Const.Opt}` +
        `${this.yOptions[this.yOptions.length - 1].value.split(Const.Opt)[1]}`;
    }
    let type = this.models[this.report.model].fields[this.report.y].field_type;
    filters = filters.filter((filter) => filter.field !== this.report.y);
    filters.push({
      field: this.report.y,
      type,
      condition: "in",
      value: yValue,
    });

    let xValue;
    j--;
    if (j < this.xOptions.length) {
      xValue = `${Const.Opt}${this.xOptions[j].value}${Const.Opt}`;
    } else {
      xValue = `${Const.Opt}${this.xOptions
        .map((opt) => opt.value)
        .join(Const.Opt)}${Const.Opt}`;
    }
    type = this.models[this.report.model].fields[this.report.x].field_type;

    filters = filters.filter((filter) => filter.field !== this.report.x);
    filters.push({
      field: this.report.x,
      type,
      condition: "in",
      value: xValue,
    });
    */

    //this.props.navigate(`/${this.report.model.replace('_', '-')}?filters=${JSON.stringify(filters)}`);
  };

  render() {

    let headers = [];
    let body = [];
    if (this.yOpts && this.zOpts && this.xOpts) {
      const row = this.yOpts.length;
      const subRow = this.zOpts.length + 1;
      const col = this.xOpts.length;
      const rows = row * subRow;

      headers = [];
      headers.push(<th key="header_0">{this.model.fields[this.report.y].label_name}</th>);
      headers.push(<th key="header_1">{this.model.fields[this.report.z].label_name}</th>);
      for (let j = 0; j < col; j++) {
        headers.push(<th key={`header_${j + 2}`}>{this.xOpts[j].label}</th>);
      }
      headers.push(<th key={`header_${col + 3}`}>Total</th>);

      body = [];
      let indy;
      for (let indx = 0; indx < rows; indx++) {
        let tr = [];
        if (indx % subRow === 0) {
          indy = indx / subRow;
          tr.push(<td rowSpan={subRow} key={`body_td_i_${indx}`} onClick={() => this.loadView(indx, 0)}>
            {this.rows[indy].label}</td>);
        }
        const indz = indx - (indy * subRow);
        if (indz === this.zOpts.length) {
          tr.push(<td key={`body_td_j_${indx}`} onClick={() => this.loadView(indx, 1)}>Total</td>);
          for (let j = 0; j < col; j++) {
            tr.push(<td key={`body_${indx}_${j}`} onClick={() => this.loadView(indx, j + 2)}>
              {this.rows[indy].colTotal[j]}</td>);
          }
          tr.push(<td key={`body_${indx}_${col}`} onClick={() => this.loadView(indx, col + 2)}>{this.rows[indy].total}</td>);
        } else {
          tr.push(<td key={`body_td_j_${indx}`} onClick={() => this.loadView(indx, 1)}>
            {this.rows[indy].subRows[indz].label}</td>);

          for (let j = 0; j < col; j++) {
            tr.push(<td key={`body_${indx}_${j}`} onClick={() => this.loadView(indx, j + 2)}>
              {this.rows[indy].subRows[indz].cols[j].count}</td>);
          }
          tr.push(<td key={`body_${indx}_${col}`} onClick={() => this.loadView(indx, col + 2)}>
            {this.rows[indy].rowTotal[indz]}</td>);
        }

        body.push(<tr key={`body_${indx}`}>{tr}</tr>);
      }


      for (let indx = 0; indx < subRow; indx++) {
        let tr = [];
        if (indx === 0) {
          tr.push(<td rowSpan={subRow} key={`body_td_i_${rows + indx}`} onClick={() => this.loadView(rows + indx, 0)}>
            Grand Total</td>);
        }
        if (indx === this.zOpts.length) {
          tr.push(<td key={`body_td_j_${rows + indx}`} onClick={() => this.loadView(rows + indx, 1)}>Grand Total</td>);
          for (let j = 0; j < col; j++) {
            tr.push(<td key={`body_${rows + indx}_${j}`} onClick={() => this.loadView(rows + indx, j + 2)}>
              {this.total.colTotal[j]}</td>);
          }
          tr.push(<td key={`body_${rows + indx}_${col}`} onClick={() => this.loadView(rows + indx, col + 2)}>
            {this.total.total}</td>);
        } else {
          tr.push(<td key={`body_td_j_${rows + indx}`} onClick={() => this.loadView(rows + indx, 1)}>
            {this.zOpts[indx].label}</td>);

          for (let j = 0; j < col; j++) {
            tr.push(<td key={`body_${rows + indx}_${j}`} onClick={() => this.loadView(rows + indx, j + 2)}>
              {this.total.counts[indx][j]}</td>);
          }
          tr.push(<td key={`body_${rows + indx}_${col}`} onClick={() => this.loadView(rows + indx, col + 2)}>
            {this.total.rowTotal[indx]}</td>);
        }

        body.push(<tr key={`body_${rows + indx}`}>{tr}</tr>);
      }
    }

    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div className="container-fluid ">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6">
                  <h4>{this.report.name}</h4>
                </div>
                <div className="col-md-6">
                  <CSVLink data={this.export} filename={`${this.report.name}.csv`}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>

            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button"
                      onClick={() => this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen })}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-3">
            <div className="container-fluid ">
              <div className="row">
                <div className={`col-md-${this.state.isFilterOpen ? 9 : 12}`}>
                  <div className="col-md-12">
                    <Table striped bordered hover>
                      <thead><tr>{headers}</tr></thead>
                      <tbody className="listlead">{body}</tbody>
                    </Table>
                  </div>
                </div>
                {this.state.isFilterOpen ?
                  <FilterPannel
                    filters={this.filters}
                    fields={this.model.fields}
                    onFilterChange={this.onFilterChange}
                    isFilterOpen={this.state.isFilterOpen}
                    restrict={this.Restrict}
                  />
                  : null
                }
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(ReportTime3D);